{
  "basicTerms": {
    "selectedOfTotal": "{selected}/{total} seleccionados",
    "search": "Buscar",
    "summary": "Resumen",
    "insights": "Perspectivas",
    "help": "Ayuda",
    "expand": "Expandir",
    "collapse": "Colapsar",
    "menu": "Menú",
    "account": "Cuenta",
    "logout": "Cerrar sesión",
    "signIn": "Iniciar sesión",
    "days": "Día | Días",
    "phone": "Teléfono",
    "subscribers": "Suscriptor | Suscriptores",
    "favorites": "Favorito | Favoritos",
    "others": "Otro | Otros",
    "yes": "Sí",
    "no": "No",
    "locations": "Ubicación | Ubicaciones",
    "active": "Activo",
    "inactive": "Inactivo",
    "all": "Todos",
    "view": "Ver",
    "language": "Idioma",
    "required": "Requerido",
    "timezone": "Zona horaria",
    "new": "Nuevo",
    "open": "Abierto",
    "close": "Cerrar",
    "closed": "Cerrado",
    "occupied": "Ocupado",
    "reserved": "Reservado",
    "enabled": "Habilitado",
    "disabled": "Deshabilitado",
    "enable": "Habilitar",
    "disable": "Deshabilitar",
    "print": "Imprimir",
    "download": "Descargar",
    "zoomIn": "Acercar",
    "zoomOut": "Alejar",
    "previous": "Anterior",
    "next": "Siguiente",
    "version": "Versión",
    "setup": "Configuración",
    "caution": "Precaución",
    "notes": "Nota | Notas",
    "add": "Agregar",
    "remove": "Eliminar",
    "duration": "Duración",
    "link": "Enlazar",
    "unlink": "Desenlazar",
    "to": "a",
    "success": "Éxito",
    "error": "Error",
    "info": "Información",
    "warning": "Advertencia",
    "time": "Hora",
    "saved": "Guardado",
    "forms": "Formulario | Formularios",
    "is": "es",
    "only": "Sólo",
    "saving": "Guardando",
    "text": "texto",
    "zip": "código postal",
    "spreadsheet": "hoja de cálculo",
    "image": "Imagen",
    "cloning": "Clonando",
    "clone": "Clonar",
    "added": "Agregado",
    "removed": "Eliminado",
    "planned": "Planificado",
    "unplanned": "No planificado",
    "checkedIn": "Registrado",
    "checkedOut": "Salida registrada",
    "more": "Más",
    "okay": "Aceptar",
    "reschedule": "Reprogramar",
    "results": "Resultado | Resultados",
    "none": "Ninguno",
    "pages": "Página | Páginas",
    "pageOfTotal": "Página {current} de {total}",
    "of": "de",
    "default": "Predeterminado",
    "soon": "pronto",
    "grid": "Cuadrícula",
    "list": "Lista",
    "booked": "Reservado",
    "arrivals": "Llegada | Llegadas",
    "early": "Temprano",
    "late": "Tarde",
    "onTime": "A tiempo",
    "area": "Área | Áreas",
    "spot": "Ubicación en patio",
    "single": "Único",
    "multiple": "Múltiple",
    "filter": "Filtro",
    "board": "Tablero",
    "at": "en",
    "from": "desde",
    "recent": "Reciente",
    "delivered": "Entregado",
    "sent": "Enviado",
    "failed": "Falló",
    "create": "Crear",
    "tasks": "Tarea | Tareas",
    "emails": "Correo electrónico | Correos electrónicos",
    "passwords": "Contraseña | Contraseñas",
    "limits": "Límites",
    "assignee": "Asignado a",
    "comment": "Comentario",
    "issue": "Problema",
    "urgent": "Urgente",
    "retry": "Reintentar",
    "custom": "Personalizado",
    "na": "N/D"
  },
  "phrases": {
    "updateEmail": "Actualizar correo electrónico",
    "copyToClipboard": "Copiar al portapapeles",
    "copiedToClipboard": "Copiado al portapapeles",
    "warehouseAddress": "Dirección del almacén",
    "cloneSchedule": "Clonar horario",
    "open24Hours": "Abierto las 24 horas",
    "featureEnabled": "Función habilitada",
    "featureDisabled": "Función deshabilitada",
    "learnMore": "Saber más",
    "minuteLabel": "{minutes} MIN",
    "minuteLabelFull": "{minutes} minutos",
    "thisActionCannotBeUndone": "esta acción NO SE PUEDE deshacer",
    "areYouSure": "¿Estás seguro?",
    "unknownUser": "Usuario desconocido",
    "leaveWithoutSaving": "Salir sin guardar",
    "learnHowItWorks": "Aprende cómo funciona",
    "allFields": "Todos los campos",
    "selectColumns": "Seleccionar columnas",
    "selectedColumns": "Columnas seleccionadas",
    "addFiles": "Agregar archivo | Agregar archivos",
    "tasks": "Sin tareas | {count} tarea | {count} tareas",
    "driversSelfCheckin": "Auto check-in del conductor",
    "addReferenceNumber": "Agregar número de referencia",
    "myAccount": "Mi cuenta",
    "mustBeAValidNumber": "Debe ser un número válido"
  },
  "messages": {
    "theConfirmationFieldDoesNotSupportPasting": "El campo de confirmación no permite pegar",
    "youMayHaveUnsavedChangesAreYouSureYouWantToLeaveThisPage": "Es posible que tengas cambios sin guardar, ¿seguro que quieres salir de esta página?",
    "browserDoesNotSupportCopyFunction": "El navegador no admite la función de copiar",
    "permissionToAccessClipboardWasDeniedToEnableAccessUpdateYourBrowserSettings": "Permiso para acceder al portapapeles denegado. Para habilitarlo, actualiza la configuración de tu navegador.",
    "alternativelyYouCanManuallyCopy": "Alternativamente, puedes copiar manualmente",
    "areYouSureYouWantToLeaveYouMayHaveUnsavedChanges": "¿Estás seguro de que deseas salir? Es posible que tengas cambios sin guardar.",
    "noResultsFound": "No se encontraron resultados",
    "maximumOfReferenceNumbersAllowedCountRemoved": "Se permite un máximo de {maxItems} números de referencia. Se eliminaron {removedCount}"
  },
  "fileFormats": {
    "jpeg": "jpeg",
    "jpg": "jpg",
    "png": "png",
    "webp": "webp",
    "pdf": "pdf"
  },
  "specialtyTerms": {
    "opendock": "Opendock",
    "warehouses": "Almacén | Almacenes",
    "carrierContacts": "Contacto del transportista | Contactos del transportista",
    "loadTypes": "Tipo de carga | Tipos de carga",
    "docks": "Muelle | Muelles",
    "appointments": "Cita | Citas",
    "users": "Usuario | Usuarios",
    "organizations": "Organización | Organizaciones",
    "orgs": "Org | Orgs",
    "companies": "Compañía | Compañías",
    "referenceNumber": "Número de referencia",
    "refNumber": "Número de referencia",
    "status": "Estado",
    "orgLoadTypes": "Tipos de carga de la organización",
    "schedulingPortal": "Portal de programación",
    "customFields": "campo personalizado | campos personalizados",
    "interval": "Intervalo",
    "drivers": "Conductor | Conductores",
    "carriers": "Transportista | Transportistas",
    "tags": "Etiqueta | Etiquetas",
    "yardManagement": "Gestión de patio",
    "carrier": "transportista | transportistas",
    "assets": "Activo | Activos",
    "tvMode": "Modo TV",
    "gridView": "Vista de cuadrícula",
    "listView": "Vista de lista",
    "gateManagement": "Gestión de acceso",
    "selfCheckIn": "auto registro",
    "gateFeed": "Feed de acceso"
  },
  "appointmentStatuses": {
    "NoShow": "No se presentó",
    "Cancelled": "Cancelado",
    "Requested": "Solicitado",
    "Scheduled": "Programado",
    "Arrived": "Llegó",
    "InProgress": "En progreso",
    "Completed": "Completado",
    "Reserves": "Reservas"
  },
  "appointmentTypes": {
    "standard": "Estándar",
    "reserved": "Reservado",
    "reserve": "Reserva"
  },
  "appointmentCreatorTypes": {
    "warehouseUser": "Usuario del almacén",
    "carrier": "Transportista"
  },
  "roles": {
    "base": "Básico",
    "carrier": "Transportista",
    "carrierAdmin": "Administrador del transportista",
    "spectator": "Espectador",
    "attendant": "Encargado",
    "operator": "Operador",
    "admin": "Administrador",
    "owner": "Propietario",
    "internal": "Interno",
    "god": "Dios"
  },
  "weekdays": {
    "sunday": "Domingo",
    "monday": "Lunes",
    "tuesday": "Martes",
    "wednesday": "Miércoles",
    "thursday": "Jueves",
    "friday": "Viernes",
    "saturday": "Sábado"
  },
  "weekdaysAbbr": {
    "sun": "Dom",
    "mon": "Lun",
    "tue": "Mar",
    "wed": "Mié",
    "thu": "Jue",
    "fri": "Vie",
    "sat": "Sáb"
  },
  "buttons": {
    "nevermind": "No importa",
    "select": "Seleccionar",
    "send": "Enviar",
    "confirm": "Confirmar",
    "next": "Siguiente",
    "previous": "Anterior",
    "create": "Crear",
    "edit": "Editar",
    "save": "Guardar",
    "yesDelete": "Sí, eliminar",
    "skipCreation": "Omitir creación",
    "cancel": "Cancelar",
    "export": "Exportar",
    "saveChanges": "Guardar cambios",
    "exportData": "Exportar datos",
    "resetToDefault": "Restablecer a predeterminado"
  },
  "tooltips": {
    "notAvailable": "No disponible",
    "notAvailableForUserRole": "No disponible para tu rol de usuario."
  },
  "errors": {
    "unkownError": "Ocurrió un error desconocido.",
    "thisFieldIsRequired": "Este campo es obligatorio",
    "passwordDoesNotMeetRequirements": "La contraseña no cumple con los requisitos",
    "emailMustBeValid": "El correo electrónico debe ser válido",
    "pleaseEnterAValidPhoneNumber": "Por favor, introduce un número de teléfono válido",
    "pleaseEnterAValidUrl": "Por favor, introduce una URL válida",
    "invalidHour": "Hora inválida",
    "invalidMinute": "Minuto inválido",
    "pleaseSelectAmOrPm": "Seleccione AM o PM",
    "pleaseEnterACompleteDateAndTime": "Ingrese una fecha y hora completas",
    "mustBeANumber": "Debe ser un número",
    "mustBeAPositiveInteger": "Debe ser un número entero positivo",
    "mustBeAWholeNumber": "Debe ser un número entero",
    "isNotAValidNumber": "no es un número válido",
    "isNotValid": "no es válido",
    "invalidUuid": "UUID inválido",
    "dateMustNotBeInThePast": "La fecha no debe estar en el pasado",
    "mustBeWithin24HoursOfStartTime": "debe estar dentro de las 24 horas desde la hora de inicio",
    "pleaseSelectAtLeast": "Por favor, selecciona al menos {requiredCount} {itemName} | Por favor, selecciona al menos {requiredCount} {itemName}s",
    "cannotSelectMoreThan": "No puedes seleccionar más de {limit} {itemName} | No puedes seleccionar más de {limit} {itemName}s",
    "fieldMustEqual": "El campo debe ser igual a {value}",
    "mustBeXCharacters": "Debe tener {length} carácter | Debe tener {length} caracteres",
    "mustBeAtLeastXCharacters": "Debe tener al menos {min} carácter | Debe tener al menos {min} caracteres",
    "mustBeAtMostXCharacters": "Debe tener como máximo {max} carácter | Debe tener como máximo {max} caracteres",
    "mustBeBetweenXAndYCharactersLong": "Debe tener entre {min} y {max} caracteres",
    "mustBeNumberBetweenXAndY": "Debe ser un número entre {min} y {max}",
    "mustBeNumberGreaterThan": "Debe ser un número mayor o igual a {min}",
    "mustBeNumberLessThan": "Debe ser un número menor que {max}",
    "mustHaveAtLeast8Characters": "Debe tener al menos 8 caracteres",
    "mustContainUpperCaseAndLowerCase": "Debe contener mayúsculas y minúsculas",
    "mustContainAtLeastOneLetter": "Debe contener al menos una letra",
    "mustContainAtLeastOneSpecialCharacter": "Debe contener al menos un carácter especial",
    "mustContainAtLeastOneNumber": "Debe contener al menos un número",
    "atLeastOneReferenceNumberIsRequired": "Se requiere al menos un {refNumberDisplayName}",
    "mustBeAValidNumber": "Debe ser un número válido"
  },
  "warehouseAmenities": {
    "lumperServices": "Servicios de descarga (lumper)",
    "overnightParking": "Estacionamiento nocturno",
    "driversRestroom": "Baño para conductores",
    "freeWiFi": "Wi-Fi gratis"
  },
  "warehousePPERequirements": {
    "safetyBoots": "Botas de seguridad",
    "safetyGlasses": "Lentes de seguridad",
    "gloves": "Guantes",
    "hardHat": "Casco",
    "faceMask": "Mascarilla",
    "noSmoking": "Prohibido fumar",
    "longPants": "Pantalones largos",
    "longSleeves": "Mangas largas",
    "highVisibilityVest": "Chaleco de alta visibilidad",
    "hairAndBeardNet": "Red para cabello y barba"
  },
  "auditLog": {
    "header": "Registro de auditoría",
    "viewAuditLog": "Ver registro de auditoría",
    "noAuditLogEvents": "No hay eventos en el registro de auditoría",
    "printedOn": "Impreso el {date}",
    "viewDetails": "Ver detalles",
    "snapshot": {
      "schedule": "Horario",
      "eta": "ETA",
      "emailSubscribers": "Suscriptores de correo",
      "customFields": "Campos personalizados",
      "statusTimes": "Horas de estado"
    },
    "timelineForAllUpdatesMadeToThis": "Cronología de todas las actualizaciones realizadas a esto",
    "hasTheWords": "contiene las palabras",
    "eventsFromDate": "Eventos desde la fecha",
    "searchEvents": "Buscar eventos",
    "by": "por",
    "appointmentUpdatesTimeline": "Historial de la cita:",
    "moreUpdates": "{count} actualizaciones más",
    "emailSubscribersUpdated": "Suscriptores de correo actualizados",
    "detailsUpdated": "Detalles actualizados",
    "recurrenceCreated": "Recurrencia creada",
    "recurrenceDeleted": "Recurrencia eliminada",
    "rescheduled": "{label} reprogramada",
    "etaUpdated": "ETA actualizado",
    "emailNotifications": "Notificaciones por correo",
    "carrierContactUpdated": "Contacto del transportista actualizado",
    "reserveTransferred": "Reserva transferida",
    "tagsUpdated": "Etiquetas actualizadas",
    "scheduled": "{label} programada",
    "statusUpdated": "Estatus actualizado",
    "timeUpdated": "Hora de {arrived} actualizada",
    "dwellTimeUpdated": "Tiempo de permanencia actualizado",
    "labelWithStatus": "{label} {status}",
    "arrivedLate": "{duration} tarde",
    "everyXAtXUntilX": "Cada {weekDays} a las {endTime} hasta el {endDate}",
    "opendockTeam": "Equipo de Opendock",
    "unknownUser": "Usuario Desconocido",
    "deleted": "Eliminado",
    "hasBeenCleared": "ha sido limpiado",
    "actionUpdated": "actualizado",
    "actionCreated": "Creado",
    "actionDeleted": "Eliminado",
    "noAction": "Sin acción",
    "emptyValue": "Valor vacío"
  },
  "timeline": {
    "createdTheTask": "creó la tarea",
    "startedTheTask": "empezó la tarea",
    "blockedTheTask": "bloqueó la tarea",
    "unblockedTheTask": "desbloqueó la tarea",
    "completedTheTask": "completó la tarea",
    "cancelledTheTask": "canceló la tarea",
    "cancelledTheReserve": "canceló la reserva",
    "cancelledTheReservationForSpot": "canceló la reserva de {areaName} - {spotCode} para esta tarea",
    "reservedSpotForThisTask": "reservó {areaName} - {spotCode} para esta tarea",
    "reservedTheSpot": "reservó la posición",
    "reason": "Motivo: {reason}",
    "addedA": "agregó",
    "reportedAn": "reportó",
    "clearedThe": "limpió",
    "flaggedTheTask": "marcó la tarea",
    "flaggedTheTaskAs": "marcó la tarea como",
    "unflaggedTheTask": "desmarcó la tarea",
    "unflaggedTheTaskAs": "desmarcó la tarea como",
    "updatedTheTask": "actualizó la tarea",
    "removedTask": "eliminó de la tarea",
    "attachments": "archivos adjuntos",
    "confirmedTheLocation": "confirmó la ubicación",
    "reportedAsMissing": "reportó como faltante",
    "noActivityYet": "No hay actividad aún",
    "noAssignee": "No hay asignado",
    "failedToFetchYardTaskTimeline": "Error al obtener cronología de tarea de patio",
    "failedToCreateComment": "Error al crear comentario"
  },
  "yardSpotStatusDialog": {
    "headers": {
      "actionThisSpot": "¿{action} esta Posición?"
    },
    "dropDownItems": {
      "cleaning": "Limpieza",
      "underMaintenance": "En Mantenimiento",
      "blockedByEquipment": "Bloqueado por Equipo",
      "safetyInspection": "Inspección de Seguridad",
      "routineInspection": "Inspección de Rutina",
      "reserved": "Reservado",
      "repairsNeeded": "Reparaciones Necesarias",
      "damage": "Daño"
    },
    "labels": {
      "reason": "Razón",
      "additionalNotes": "Notas Adicionales"
    },
    "placeholders": {
      "selectAReason": "Seleccione una razón",
      "enterAdditionalNotes": "Ingrese notas adicionales"
    },
    "messages": {
      "thisSpotWillRemainUnavailable": "Esta posición permanecerá no disponible para asignación de activos hasta que se establezca como abierta nuevamente.",
      "thisDoorWillBeSetAsOpen": "Esta puerta se establecerá como abierta y estará disponible nuevamente para asignación de activos.",
      "assetInTransitClosingWillBlockMove": "El activo {assetCode} está en tránsito hacia esta posición. Cerrarla impedirá que se complete el movimiento."
    }
  },
  "tasks": {
    "presenter": {
      "unassigned": "Sin asignar",
      "noDueDate": "Sin fecha límite",
      "fromAnySpot": "Desde cualquier lugar",
      "toAnySpot": "Hacia cualquier lugar",
      "anyAsset": "Cualquier activo",
      "types": {
        "move": "Mover"
      },
      "status": {
        "toDo": "Por Hacer",
        "inProgress": "En Progreso",
        "completed": "Completado",
        "canceled": "Cancelado"
      },
      "issue": "Problema",
      "relatedEntity": {
        "spotArea": "Área",
        "spot": "Lugar",
        "asset": "Activo"
      }
    }
  },
  "readyForPickupNotificationDialog": {
    "title": "Notificación de Listo para Recolección",
    "messages": {
      "body": "Envíe un correo electrónico a los siguientes contactos informando que el activo {assetContainerCode} está listo para ser recogido en {warehouseName}.",
      "notificationSent": "Notificación enviada exitosamente.",
      "notificationFailed": "Error al enviar la notificación. Inténtalo de nuevo."
    },
    "labels": {
      "notifyTheseContacts": "Notificar estos contactos:",
      "suggestedContacts": "Contactos sugeridos:"
    },
    "buttons": {
      "skipNotification": "Omitir notificación"
    }
  },
  "chipList": {
    "keys": {
      "enter": "enter",
      "tab": "tab"
    },
    "messages": {
      "pressEnterOrTabToActionEntity": "Presiona {enterKey} o {tabKey} para {action} {entity}",
      "pressEnterOrTabToAddEmail": "Presiona {enterKey} o {tabKey} para agregar un correo electrónico"
    },
    "placeholders": {
      "emailSubscribers": "Suscriptores de Correo Electrónico"
    }
  }
}
